<template>
  <v-layout class="row wrap mx-0 white">
    <v-flex
      xs12
      py-0
      class="d-flex align-center"
    >
      <v-form
        ref="form"
        :value="value"
      >
        <v-tabs-items
          v-model="tabActive"
          vertical
        >
          <v-tab-item
            v-for="(group, gr) in tabs"
            :key="gr"
            :value="'tab-' + group.name"
          >
            <v-layout pa-4 row wrap fill-height align-center>
              <template v-for="(item, i) in fields">
                <comp-fields
                  :key="i"
                  v-if="item.tabID == group.id && item.type == 'text'"
                  v-model="dataform[item.name]"
                  :placeholder="item.placeholder"
                  :sensitive="item.sensitive"
                  :rules="item.rules"
                  :classes="item.classes"
                  :outline="item.outline"
                  :box="item.box"
                  :hint="item.hint"
                  :readonly="item.readonly"
                  :disabled="item.disabled"
                  :persistentHint="item.persistentHint"
                  :label="item.label"
                />
                <comp-field-birth-date
                  :key="i" 
                  v-if="item.tabID == group.id && item.type == 'birthDate'"
                  v-model="dataform[item.name]"
                  :placeholder="item.placeholder"
                  :sensitive="item.sensitive"
                  :rules="item.rules"
                  :classes="item.classes"
                  :outline="item.outline"
                  :box="item.box"
                  :hint="item.hint"
                  :readonly="item.readonly"
                  :disabled="item.disabled"
                  :persistentHint="item.persistentHint"
                  :label="item.label"
                />
                <comp-field-time-picker
                  :key="i" 
                  v-if="item.tabID == group.id && item.type == 'time'"
                  v-model="dataform[item.name]"
                  :placeholder="item.placeholder"
                  :sensitive="item.sensitive"
                  :rules="item.rules"
                  :classes="item.classes"
                  :outline="item.outline"
                  :box="item.box"
                  :hint="item.hint"
                  :readonly="item.readonly"
                  :disabled="item.disabled"
                  :persistentHint="item.persistentHint"
                  :label="item.label"
                />
                <comp-field-date
                  :key="i" 
                  v-if="item.tabID == group.id && item.type == 'date'"
                  v-model="dataform[item.name]"
                  :placeholder="item.placeholder"
                  :sensitive="item.sensitive"
                  :rules="item.rules"
                  :classes="item.classes"
                  :outline="item.outline"
                  :box="item.box"
                  :hint="item.hint"
                  :readonly="item.readonly"
                  :disabled="item.disabled"
                  :persistentHint="item.persistentHint"
                  :label="item.label"
                />
                <comp-field-array-table
                  :key="i"
                  v-if="item.tabID == group.id && item.type == 'array'"
                  :headersItems="item.headers"
                  :dataItems="dataform[item.name]"
                  :noResultText="item.noResultText"
                  :hideActions="item.hideActions"
                />     
                <comp-array-fields
                  :key="i"
                  v-if="item.tabID == group.id && item.type == 'arrayField'"
                  v-model="dataform[item.name]"
                  :placeholder="item.placeholder"
                  :sensitive="item.sensitive"
                  :rules="item.rules"
                  :classes="item.classes"
                  :outline="item.outline"
                  :box="item.box"
                  :hint="item.hint"
                  :persistentHint="item.persistentHint"
                  :label="item.label"
                />          
              </template>
            </v-layout>
          </v-tab-item>
        </v-tabs-items>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['value', 'tabActive', 'tabs', 'fields', 'dataform'],
  methods: {
    validateForm() {
      var valid = this.$refs.form.validate()
      this.$emit('input', valid)
      return valid
    }
  }
}
</script>
